// H71 · Lógica pura del selector de beneficiario (hoja con buscador).

import type { SeccionSeleccion } from '#components/mobile/ui/HojaSeleccion';

import { anadirReciente } from './seleccionCategoria';

/** Beneficiarios recientes que se enseñan arriba. */
export const NUM_RECIENTES_BENEFICIARIO = 5;

const CLAVE_RECIENTES = 'rumbo-beneficiarios-recientes';

type Beneficiario = {
  id: string;
  name: string;
  transfer_acct?: string | null;
};

/**
 * Categoría habitual de cada beneficiario: la de su movimiento categorizado
 * más reciente. `filas` llega ordenada de más nueva a más antigua.
 */
export function habitualesPorBeneficiario(
  filas: ReadonlyArray<{ payee: string | null; category: string | null }>,
): Map<string, string> {
  const mapa = new Map<string, string>();
  for (const { payee, category } of filas) {
    if (payee && category && !mapa.has(payee)) {
      mapa.set(payee, category);
    }
  }
  return mapa;
}

type EntradaSecciones = {
  beneficiarios: ReadonlyArray<Beneficiario>;
  recientes: ReadonlyArray<string>;
  /** Nombre de la categoría habitual de cada beneficiario (si la tiene). */
  habitual: (id: string) => string | undefined;
  titulos: { recientes: string; todos: string };
};

/**
 * «Recientes» (atajo) y «Todos» por orden alfabético. Los beneficiarios de
 * traspaso (las cuentas) no salen: el traspaso tiene su propia fila.
 */
export function seccionesBeneficiario({
  beneficiarios,
  recientes,
  habitual,
  titulos,
}: EntradaSecciones): SeccionSeleccion[] {
  const propios = beneficiarios.filter(b => !b.transfer_acct && b.name);
  const porId = new Map(propios.map(b => [b.id, b]));
  const fila = (b: Beneficiario) => ({
    id: b.id,
    nombre: b.name,
    detalle: habitual(b.id),
  });
  const secciones: SeccionSeleccion[] = [];
  const ultimos = recientes
    .map(id => porId.get(id))
    .filter((b): b is Beneficiario => b != null)
    .slice(0, NUM_RECIENTES_BENEFICIARIO);
  if (ultimos.length > 0) {
    secciones.push({
      id: 'recientes',
      titulo: titulos.recientes,
      icono: 'clock',
      atajo: true,
      filas: ultimos.map(fila),
    });
  }
  secciones.push({
    id: 'todos',
    titulo: titulos.todos,
    contador: propios.length,
    filas: [...propios]
      .sort((a, b) => a.name.localeCompare(b.name, 'es'))
      .map(fila),
  });
  return secciones;
}

export function leerBeneficiariosRecientes(): string[] {
  try {
    const crudo = window.localStorage.getItem(CLAVE_RECIENTES);
    const lista: unknown = crudo ? JSON.parse(crudo) : [];
    return Array.isArray(lista)
      ? lista.filter((x): x is string => typeof x === 'string')
      : [];
  } catch {
    return [];
  }
}

export function guardarBeneficiarioReciente(id: string): void {
  try {
    window.localStorage.setItem(
      CLAVE_RECIENTES,
      JSON.stringify(anadirReciente(leerBeneficiariosRecientes(), id)),
    );
  } catch {
    // Sin almacenamiento (modo privado): no se recuerdan.
  }
}
